import PropTypes from 'prop-types';
import SimpleCardList from 'components/SimpleCardList';
import { getCMSDocumentSrc } from 'utils/getCMSDocumentSrc';

/**
 * Lista de cards simple. SimpleCardList internamente renderiza un stack
 * de cards; en desktop lo centramos con max-w para evitar estiramiento.
 */
const SimpleCardListBlock = ({ value, renderCmsItem = null }) => {
  const cards = (value?.items || []).map((item) => {
    const content = renderCmsItem ? renderCmsItem(item) : null;
    if (content) {
      return { id: item.id, content };
    }
    return {
      id: item.id,
      ...item.value,
      image: item?.value?.image?.hash ? getCMSDocumentSrc(item.value.image) : null,
    };
  });

  if (!cards.length) {
    return null;
  }

  return (
    <section className='cms-block cms-block--simple-card-list py-6 md:py-6 lg:py-8'>
      <div className='w-full md:max-w-3xl lg:max-w-5xl mx-auto px-6'>
        <SimpleCardList
          title={value?.title || ''}
          cards={cards}
        />
      </div>
    </section>
  );
};

SimpleCardListBlock.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.array,
  }).isRequired,
  renderCmsItem: PropTypes.func,
};

export default SimpleCardListBlock;
